import {Component, OnDestroy, OnInit} from "@angular/core";
import {FamilleFacturationSavedSupplier, FamilleFacturationService} from "../../../core/services/entities/famille-facturation.service";
import {ElementFacturableDTO} from "../../../core/dtos/ElementFacturableDTO";
import {Subscription} from "rxjs";
import {FamilleFacturationDto} from "../../../core/dtos/facturation/clients/famille-facturation/famille-facturation-dto";
import {UtilsService} from "../../../core/utils/utils.service";
import {confirm} from "devextreme/ui/dialog";
import {ResponseWrapper} from "../../../core/suppliers/wrappers/response-wrapper";
import {IsDeletableObject} from "../../../core/models/is-deletable-object";
import {MSG_KEY, MSG_SEVERITY} from "../../../core/constants";
import {InternationalizationService} from "../../../core/services/i8n/i8n.service";
import {ToastService} from "../../../core/services/technique/toast.service";
import {ButtonThemeEnum} from "../../../shared/ui/button/button-theme-enum";


@Component({
  selector: 'yo-famille-facturation',
  templateUrl: './famille-facturation.component.html',
  styleUrls: ['./famille-facturation.component.scss'],
  standalone: false
})
export class FamilleFacturationComponent implements OnInit, OnDestroy {

  subFamillesFacturation: Subscription;
  subUpdateFamillesFacturation: Subscription
  familleFacturations: FamilleFacturationDto[] = [];
  deleteSub: Subscription;
  displayDeletePopupErrors: boolean;

  selectedRows: number[] = [];
  errors: any[] = [];

  constructor(public familleFacturationSvc: FamilleFacturationService,
              public utilsSvc: UtilsService,
              public i8nSvc: InternationalizationService,
              public toastSvc: ToastService) {
  }

  ngOnInit(): void {
    this.initData();
    this.updateElementsFacturables();
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subFamillesFacturation);
    this.utilsSvc.unsubscribe(this.subUpdateFamillesFacturation);
  }

  updateElementsFacturables = (): void => {
    this.subUpdateFamillesFacturation = this.familleFacturationSvc.familleFacturationSaved$
      .subscribe((response: FamilleFacturationSavedSupplier) => {
        if (response.isUpdate) {
          const idx: number = this.familleFacturations.findIndex(familleFacturation => familleFacturation.id === response.familleFacturation.id);
          this.familleFacturations[idx] = response.familleFacturation;
        } else {
          this.familleFacturations.push(response.familleFacturation);
        }
      });
  };

  initData(): void {
    this.subFamillesFacturation = this.familleFacturationSvc.findAllFamillesFacturation().subscribe(response => {
      this.familleFacturations = response.allFamilleFacturation;
    });
  }

  openDialogEdition = (elementFacturable: ElementFacturableDTO): void => {
    this.familleFacturationSvc.announceOpenDialogEdition(elementFacturable);
  };

  canDelete = (): boolean => this.selectedRows.length > 0;

  deleteValues = async (): Promise<void> => {

    let idsToDeleteInTable = Object.assign([], this.selectedRows);

    const isDeletionValidated: boolean = await confirm(this.i8nSvc.getLabelFromCode(idsToDeleteInTable.length > 1 ? 'CONFIRM_DELETION_PLURAL' : 'CONFIRM_DELETION_SINGULAR', null), this.i8nSvc.getLabelFromCode("Suppression", null));

    if (!isDeletionValidated)
      return new Promise(null);

    this.deleteSub = this.familleFacturationSvc.deleteFamilleFacturation(this.selectedRows).subscribe(response => {
      const res: any = (response as ResponseWrapper<IsDeletableObject>).one;

      if (res) {
        if (res.messagesErrorList && res.messagesErrorList.length > 0) {
          for (const error of res.messagesErrorList) {
            const elementToKeep = this.familleFacturations.find(familleFacturation => familleFacturation.code === error.args);
            idsToDeleteInTable = idsToDeleteInTable.filter(id => elementToKeep.id !== id);
          }
        } else {
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, this.i8nSvc.getLabelFromCode(idsToDeleteInTable.length > 1 ? `DELETION_COMPLETED_PLURAL` : `DELETION_COMPLETED_SINGULAR`, null));
        }
        this.familleFacturations = this.familleFacturations.filter(pointFacturation => !idsToDeleteInTable.find(id => id === pointFacturation.id));
      }
    });
  }

  public readonly ButtonThemeEnum = ButtonThemeEnum;
}
